export enum AppEnv {
  DEV = 'dev', // for localhost
  LOCAL_TEST = 'local-test',
  TEST = 'test', // for deployment on test.efacity.com
  CI = 'ci', // CI environment
  PROD = 'prod' // for deployment on efacity.com
}
